// extracted by mini-css-extract-plugin
module.exports = {"section__wrapper":"c_b contentWrapper","content__wrapperMain":"c_j","content__wrapperContent":"c_k","content__sectionLabel":"c_l sectionHeader"};